import { c as _c } from "react/compiler-runtime";
import { isString } from '@netpurpose/types';
import { setUser } from '@sentry/nextjs';
import { useEffect } from 'react';
import { useLoggedIn } from '../useLoggedIn/useLoggedIn';
export const useSentryUser = () => {
  const $ = _c(5);
  const {
    user
  } = useLoggedIn();
  const userId = user?.id;
  const userEmail = user?.email;
  const userName = `${user?.firstName} ${user?.lastName}`;
  let t0;
  let t1;
  if ($[0] !== userEmail || $[1] !== userId || $[2] !== userName) {
    t0 = () => {
      const emailDomain = isString(userEmail) ? userEmail.split("@")?.[1] || "" : "";
      const userIsNetPurposeEmployee = emailDomain === "netpurpose.com";
      const userIsCloudFactoryEmployee = emailDomain.includes("cloudfactory");
      const extraInfo = userIsNetPurposeEmployee || userIsCloudFactoryEmployee ? {
        email: userEmail || "",
        username: userName
      } : {
        email: `<redacted>@${emailDomain}`,
        username: `User at ${emailDomain}`
      };
      setUser(userId ? {
        id: userId,
        ...extraInfo
      } : null);
    };
    t1 = [userId, userEmail, userName];
    $[0] = userEmail;
    $[1] = userId;
    $[2] = userName;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};